function cov_y2oy7onc2() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatInactive.tsx";
  var hash = "e8694405215aa9ba0e6d2eae76cba18eafb1485f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/ChatInactive.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 53
        },
        end: {
          line: 4,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e8694405215aa9ba0e6d2eae76cba18eafb1485f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_y2oy7onc2 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_y2oy7onc2();
var Icon = (cov_y2oy7onc2().s[0]++, {
  name: 'chat-inactive',
  svg: "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.3184 15.5L19.5 18.5665V5C19.5 4.72386 19.2761 4.5 19 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V15C4.5 15.2761 4.72386 15.5 5 15.5H15.3184ZM14.5 18L20.4086 22.333C21.0692 22.8174 22 22.3457 22 21.5266V5C22 3.34315 20.6569 2 19 2H5C3.34315 2 2 3.34315 2 5V15C2 16.6569 3.34315 18 5 18H14.5Z\" fill=\"currentColor\"/>"
});
export default Icon;